require('./brokerWarrantsAdvancedSellStep1.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');

// @ commons
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const BuySellConditionTypeDropdown = require('components/broker/commons/buySellConditionTypeDropdown/buySellConditionTypeDropdown');
const { InputSafe } = require('commonsComponents/inputSafe');
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const { OKMessage } = require('commonsComponents/OKMessage');
const { AmountInput } = require('commonsComponents/amountInput');

// @ helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { nonNumericFilter } = require('utilities/stringHelper');

// @constants
const {
    FIRST_STEP,
    BROKER_CONDITION_OVER_WARRANT_PRICE,
    BROKER_CONDITION_OVER_UNDERLYING_PRICE,
    BROKER_DAILY_LOWERING_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_DAILY_RACING_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_INTRADAY_DOWN_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_INTRADAY_UP_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_STOCKS_ADVANCED_BUY_AMOUNT_FIELDS_MAXLENGHT_LIMIT,
    BROKER_STOCKS_ADVANCED_BUY_PERCENTAGE_FIELDS_MAXLENGHT_LIMIT,
    BROKER_INDEX_ORDER_CONDITION_VALUE,
    EURO_TEXT
} = require('constants/index');
const language = getLanguage();
const { DATE_PICKER_CUSTOM_PLACEHOLDER, DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

// @ actions
const BrokerWarrantsAdvancedSellActions = require('actions/brokerWarrantsAdvancedSell');

class BrokerWarrantsAdvancedSellStep1 extends React.Component {

    constructor(props) {
        super(props);
        this.handleConditionTypeValueChanged = this.handleConditionTypeValueChanged.bind(this);
        this.onAmountFieldChange = this.onAmountFieldChange.bind(this);
    }

    onAmountFieldChange(value) {
        this.props.handleConditionTypeValueChanged(value);
    }

    buildAmountField() {
        const { immBrokerWarrantsAdvancedSell } = this.props;
        const conditionTypeValue = immBrokerWarrantsAdvancedSell.getIn(['steps', FIRST_STEP, 'conditionTypeValue']);

        return (
            <div className="warrants-advanced-buy-step1__condition-type-value-input">
                <AmountInput
                    amount={conditionTypeValue}
                    callback={this.onAmountFieldChange}
                    max={BROKER_STOCKS_ADVANCED_BUY_AMOUNT_FIELDS_MAXLENGHT_LIMIT}
                    className="warrants-advanced-buy-step1__condition-type-value-label"
                    language={language}
                    hideFocusZero
                />
            </div>
        );
    }

    buildConditionTypeValueSection() {
        const { immBrokerWarrantsAdvancedSell } = this.props;
        const conditionType = immBrokerWarrantsAdvancedSell.getIn(['steps', FIRST_STEP, 'conditionType']);
        const orderConditionValue = immBrokerWarrantsAdvancedSell.getIn(['steps', FIRST_STEP, 'orderConditionValue']);
        let conditionTypeValueField;
        let conditionTypeValueFieldLabelKey;
        let conditionTypeValueFieldLabelKeyParams;

        switch (conditionType) {
            case BROKER_DAILY_LOWERING_PERCENTAGE_GRATER_THAN_CONDITION_ID:
            case BROKER_DAILY_RACING_PERCENTAGE_GRATER_THAN_CONDITION_ID:
            case BROKER_INTRADAY_DOWN_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID:
            case BROKER_INTRADAY_UP_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID:
                conditionTypeValueField = this.buildPercentageField();
                conditionTypeValueFieldLabelKey = 'broker-stocksAdvancedSellConditionTypePercentageValue';
                conditionTypeValueFieldLabelKeyParams = [];
                break;
            default:
                conditionTypeValueField = this.buildAmountField()
                conditionTypeValueFieldLabelKey = 'broker-warrantsAdvancedSellConditionTypeAmountOrPointsValue';
                conditionTypeValueFieldLabelKeyParams = [(orderConditionValue === BROKER_INDEX_ORDER_CONDITION_VALUE) ? formatText('broker-pointsText') : EURO_TEXT];
                break;
        }

        return (
            <div className="warrants-advanced-buy-step1__condition-type-value-section warrants-advanced-buy-step1__section-subtitle">
                <FormattedText value={conditionTypeValueFieldLabelKey} injectedStrings={conditionTypeValueFieldLabelKeyParams} className="warrants-advanced-buy-step1__condition-type-value-label" />
                {conditionTypeValueField}
            </div>
        );
    }

    buildPercentageField() {
        const { immBrokerWarrantsAdvancedSell } = this.props;
        const conditionTypeValue = immBrokerWarrantsAdvancedSell.getIn(['steps', FIRST_STEP, 'conditionTypeValue']);

        return (
            <div className="warrants-advanced-buy-step1__condition-type-value-input">
                <InputSafe
                    type="text"
                    value={conditionTypeValue}
                    autoComplete="off"
                    onChange={this.handleConditionTypeValueChanged}
                    maxLength={BROKER_STOCKS_ADVANCED_BUY_PERCENTAGE_FIELDS_MAXLENGHT_LIMIT}
                />
            </div>
        );
    }

    handleConditionTypeValueChanged(event) {
        const filteredValue = nonNumericFilter(event.target.value);
        this.props.handleConditionTypeValueChanged(filteredValue);
    }

    render() {
        const {
            immBrokerWarrantsAdvancedSell,
            handleOrderTermsChanged,
            handleConditionTypeChanged,
            orderTermValidityDateChanged
        } = this.props;

        const step1 = immBrokerWarrantsAdvancedSell.getIn(['steps', FIRST_STEP]);
        const orderType = step1.get('orderType');
        const conditionType = step1.get('conditionType');
        const conditionTypeValueSection = this.buildConditionTypeValueSection();
        const limitDate = step1.get('limitDate');
        const validityDate = step1.get('validityDate');

        return (
            <div className="warrants-advanced-buy-step1">
                <header className="warrants-advanced-buy-step1__header">
                    <h2 className="warrants-advanced-buy-step1__header-title">
                        <FormattedText value="broker-warrantsAdvancedBuyHeaderTitle" />
                    </h2>
                </header>
                <section className={"warrants-advanced-buy-step1__group-div"}>
                    <div className="warrants-advanced-buy-step1__subgroup-div">
                        <h4 className="warrants-advanced-buy-step1__section-subtitle">
                            <FormattedText value="broker-stocksAdvancedBuyOrderTypeSubtitle" />
                            <OKTooltip
                                content="broker-todoTooltip"
                                offset={[0, -15]}
                            />
                        </h4>
                        <RadioButtonGroup
                            selectedValue={orderType}
                            onChange={handleOrderTermsChanged}
                            name="orderTermsRadioGroup"
                            idPrefix="orderTermsRadioGroup"
                        >
                            <RadioButton
                                label={formatText('broker-warrantsAdvancedSellConditionalWarrantPrice')}
                                value={BROKER_CONDITION_OVER_WARRANT_PRICE}
                                className="warrants-advanced-buy-step1__radio-button"
                            />
                            <RadioButton
                                label={formatText('broker-warrantsAdvancedBuyConditionalUnderlyingPrice')}
                                value={BROKER_CONDITION_OVER_UNDERLYING_PRICE}
                                className="warrants-advanced-buy-step1__radio-button"
                            />
                        </RadioButtonGroup>
                    </div>
                </section>
                <div className="warrants-advanced-buy-step1__group-div">
                    <h3 className="warrants-advanced-buy-step1__section-title">
                        <FormattedText value="broker-warrantsAdvancedSellConditionEventSectionTitle" />
                    </h3>

                    <div className="warrants-advanced-buy-step1__subgroup-div">

                        <div className="warrants-advanced-buy-step1__condition-type-dropdown">
                            <BuySellConditionTypeDropdown
                                onConditionTypeChange={handleConditionTypeChanged}
                                selectedValue={conditionType}
                            />
                        </div>
                        {conditionTypeValueSection}
                    </div>
                    <div className="warrants-advanced-buy-step1__subgroup-div">
                        <h4 className="warrants-advanced-buy-step1__section-subtitle warrants-advanced-buy-step1__clear">
                            <FormattedText value="broker-stocksAdvancedBuyValidityDateSubtitle" />
                            <OKTooltip
                                content="broker-todoTooltip"
                                offset={[0, -15]}
                            />
                        </h4>
                        <DatePickerCustom
                            callback={orderTermValidityDateChanged}
                            selectedDate={validityDate}
                            maxDate={limitDate}
                            placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                            locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                            dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                        />
                    </div>
                </div>
                <div className="warrants-advanced-buy-step1__group-div">
                    <OKMessage
                        id="warrants-advanced-buy-step3-disclaimer"
                        type="informative"
                        visible={true}
                        extraClass="warrants-advanced-buy-step1__disclaimer"
                    >
                        <span className="warrants-advanced-buy-step1__disclaimer-block">
                            <FormattedText value="broker-warrantsAdvancedBuyStep1DisclaimerFirstPart" />
                        </span>
                        <span className="warrants-advanced-buy-step1__disclaimer-block">
                            <FormattedText value="broker-warrantsAdvancedBuyStep1DisclaimerSecondPart" />
                        </span>
                    </OKMessage>
                </div>
            </div>
        );
    }
}

BrokerWarrantsAdvancedSellStep1.propTypes = {
    immBrokerWarrantsAdvancedSell: PropTypes.object.isRequired,
    handleOrderTermsChanged: PropTypes.func.isRequired,
    handleConditionTypeChanged: PropTypes.func.isRequired,
    handleConditionTypeValueChanged: PropTypes.func.isRequired,
    orderTermValidityDateChanged: PropTypes.func.isRequired
};

module.exports.constructor = BrokerWarrantsAdvancedSellStep1;

module.exports.BrokerWarrantsAdvancedSellStep1 = connect(state => ({
    immBrokerWarrantsAdvancedSell: state.brokerWarrantsAdvancedSell
}), {
        handleOrderTermsChanged: BrokerWarrantsAdvancedSellActions.orderTermsChanged,
        handleConditionTypeChanged: BrokerWarrantsAdvancedSellActions.conditionTypeChanged,
        handleConditionTypeValueChanged: BrokerWarrantsAdvancedSellActions.conditionTypeValueChanged,
        orderTermValidityDateChanged: BrokerWarrantsAdvancedSellActions.orderTermValidityDateChanged
    })(BrokerWarrantsAdvancedSellStep1);
